module.exports = __webpack_public_path__ + "SampleLogo.png";